import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, DialogContentText, TextField } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';


type PromptDialogProps = {
    description?: React.ReactNode,
    value?: string,
    required?: boolean,
    rows?: number,
} & ModalActionProps<string>;

const PromptDialog = ({ description, value, onFinish, required, rows = 1 }: PromptDialogProps) => {
    const {t} = useTranslation();
    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onFinish(new FormData(event.currentTarget).get('value') as string);
    };

    return (
        <Box component="form" onSubmit={submit}>
            {description && (
                <DialogContent>
                    <DialogContentText>{description}</DialogContentText>
                </DialogContent>
            )}

            <DialogContent>
                <TextField
                    fullWidth
                    multiline={rows > 1}
                    variant="outlined"
                    rows={rows}
                    autoFocus
                    required={required}
                    id="prompt-value"
                    name="value"
                    defaultValue={value}
                />
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('apply')}</Button>
            </DialogActions>
        </Box>
    );
};

export default PromptDialog;
